module.exports = __webpack_public_path__ + "static/img/text01.05c9e9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cert/text01.jpg
// module id = KoBw
// module chunks = 126